export class TermoAceitePrintEntity {
  empresa = null;
  contratante = null;
  acessoriosList = [];
  locaisList = [];
  tiposList = [];

  constructor(
    empresa,
    clienteSelecionado,
    acessoriosAtivo,
    locaisAvaria,
    tiposAvaria,
  ) {
    this.empresa = new Empresa(empresa);
    this.contratante = clienteSelecionado
      ? new Contratante(clienteSelecionado)
      : null;
    this.acessoriosList = (acessoriosAtivo || []).map((acessorio) => ({
      id: acessorio.id,
      descricao: acessorio.descricao,
    }));
    this.locaisList = (locaisAvaria || []).map((local) => ({
      id: local.id,
      descricao: local.descricao,
      componentes: (local.componentes || []).map((componente) => ({
        id: componente.id,
        descricao: componente.descricao,
      })),
    }));
    this.tiposList = (tiposAvaria || []).map((tipo) => ({
      id: tipo.id,
      descricao: tipo.descricao,
    }));
  }
}

class Empresa {
  constructor(empresa) {
    this.fantasia = empresa?.fantasia || null;
    this.cnpjCpf = empresa?.cnpjCpf || null;
    this.enderecoLogradouro = empresa?.enderecoLogradouro || null;
    this.enderecoLogradouroNumero = empresa?.enderecoLogradouroNumero || null;
    this.enderecoBairro = empresa?.enderecoBairro || null;
    this.enderecoCidade = empresa?.enderecoCidade || null;
    this.enderecoUF = empresa?.enderecoUF || null;
    this.enderecoCep = empresa?.enderecoCep || null;
    this.telefone = empresa?.telefone || null;
    this.email = empresa?.email || null;
  }
}

class Contratante {
  constructor(cliente) {
    const endereco = cliente?.enderecos?.[0];
    this.nomeRazaoSocial = cliente?.nomeRazaoSocial || null;
    this.cnpjCpf = cliente?.cnpjCpf || null;
    this.enderecoLogradouro = endereco?.logradouro || null;
    this.enderecoLogradouroNumero = endereco?.numero || null;
    this.enderecoBairro = endereco?.bairro || null;
    this.enderecoCidade = endereco?.cidade?.nome || null;
    this.enderecoUF = endereco?.cidade?.estado?.sigla || null;
    this.enderecoCep = endereco?.cep || null;
  }
}
